// Save the first landing-page URL into attributes[landing_site_url].
(function () {
  if (window.__landingSiteAttrInit) return;
  window.__landingSiteAttrInit = true;

  var LANDING_KEY = 'landing_site_url';
  var INPUT_SELECTOR = 'input[name="attributes[landing_site_url]"]';
  var cachedLandingUrl = null;

  function safeGetStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSetStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

  function getLandingSiteUrl() {
    if (cachedLandingUrl) return cachedLandingUrl;
    var current = window.location.href || '';
    var stored = safeGetStorage(LANDING_KEY);
    if (!stored) {
      safeSetStorage(LANDING_KEY, current);
      stored = current;
    }
    cachedLandingUrl = stored || current;
    return cachedLandingUrl;
  }

  function syncLandingInputs(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var value = getLandingSiteUrl();
    var fields = root.querySelectorAll(INPUT_SELECTOR);
    if (!fields.length) return;
    fields.forEach(function (field) {
      if (field.value !== value) field.value = value;
    });
  }

  function bindFormSubmitSync() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.querySelector) return;
        var field = form.querySelector(INPUT_SELECTOR);
        if (!field) return;
        field.value = getLandingSiteUrl();
      },
      true
    );
  }

  syncLandingInputs(document);
  bindFormSubmitSync();
  document.addEventListener('DOMContentLoaded', function () {
    syncLandingInputs(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    syncLandingInputs(e.target || document);
  });
})();


// Scroll the buy-now button to the target purchase block.
(function () {
  if (window.__wnowAnchorScrollBound) return;
  window.__wnowAnchorScrollBound = true;
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest('.wnow-btn[data-wnow-anchor="true"]');
      if (!a) return;
      var id = (a.getAttribute('data-wnow-target') || '').replace('#', '').trim();
      if (!id) {
        var href = a.getAttribute('href') || '';
        var hashIndex = href.indexOf('#');
        if (hashIndex >= 0) {
          id = href.slice(hashIndex + 1);
        }
      }
      if (!id) return;
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    false
  );
})();

// Keep the desktop landing-page zoom synced after page load with debouncing.
(function () {
  if (window.__mainContentZoomInit) return;
  window.__mainContentZoomInit = true;

  var zoomConfig = window.__mainContentZoomConfig || {};
  var DESIGN_WIDTH = zoomConfig.designWidth || 1920;
  var MOBILE_MAX = zoomConfig.mobileMax || 767;
  var DEBOUNCE_MS = zoomConfig.debounceMs || 120;
  var rafId = null;
  var debounceTimer = null;

  function getViewportWidth() {
    return document.documentElement.clientWidth || window.innerWidth || 0;
  }

  function clearMainContentZoom() {
    document.documentElement.style.removeProperty('--main-content-zoom');
    document.documentElement.classList.remove('has-main-content-zoom');
  }

  function applyMainContentZoom() {
    var vw = getViewportWidth();
    if (vw <= 0) return;

    if (vw <= MOBILE_MAX) {
      clearMainContentZoom();
      return;
    }

    var z = vw / DESIGN_WIDTH;
    document.documentElement.style.setProperty('--main-content-zoom', z);
    document.documentElement.classList.add('has-main-content-zoom');
  }

  function scheduleApply(delay) {
    var wait = typeof delay === 'number' ? delay : DEBOUNCE_MS;
    if (debounceTimer != null) {
      window.clearTimeout(debounceTimer);
    }

    debounceTimer = window.setTimeout(function () {
      debounceTimer = null;

      if (rafId != null) {
        window.cancelAnimationFrame(rafId);
      }

      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        applyMainContentZoom();
      });
    }, wait);
  }

  window.__applyMainContentZoom = applyMainContentZoom;
  window.__scheduleMainContentZoom = scheduleApply;

  window.addEventListener('load', function () {
    scheduleApply(0);
  }, { once: true });
  window.addEventListener('pageshow', function () {
    scheduleApply(0);
  });
  window.addEventListener('resize', function () {
    scheduleApply();
  }, { passive: true });

  if (document.readyState === 'complete') {
    scheduleApply(0);
  } else if (document.readyState === 'interactive') {
    scheduleApply(0);
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleApply(0);
      },
      { once: true }
    );
  }
})();


// Animate numbers when .animation-number enters the viewport.
(function () {
  if (window.__animationNumberInit) return;
  window.__animationNumberInit = true;

  function digitsFromText(el) {
    var raw = (el.textContent || '').replace(/[^\d]/g, '');
    var n = parseInt(raw, 10);
    return isNaN(n) || n < 0 ? 0 : n;
  }

  function formatInt(n) {
    return Math.round(n).toLocaleString();
  }

  function animateOne(el) {
    if (el.getAttribute('data-count-done') === '1') return;
    var target = digitsFromText(el);
    if (target <= 0) return;

    var duration = 2200;
    var startTs = null;
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }
    function frame(ts) {
      if (startTs == null) startTs = ts;
      var p = Math.min(1, (ts - startTs) / duration);
      var eased = easeOutCubic(p);
      el.textContent = formatInt(eased * target);
      if (p < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = formatInt(target);
        el.setAttribute('data-count-done', '1');
      }
    }
    el.textContent = formatInt(0);
    requestAnimationFrame(frame);
  }

  function bind() {
    var nodes = document.querySelectorAll('.animation-number');
    if (!nodes.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            animateOne(entry.target);
          });
        },
        { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
      );
      nodes.forEach(function (n) {
        io.observe(n);
      });
    } else {
      nodes.forEach(animateOne);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

// Compute and update discount badges for buy-now button groups.
(function () {
  if (window.__wnowDiscountInit) return;
  window.__wnowDiscountInit = true;

  function toNumber(val) {
    if (val == null) return 0;
    var normalized = String(val).replace(/[^0-9.\-]/g, '');
    var n = parseFloat(normalized);
    return isNaN(n) ? 0 : n;
  }

  function applyDiscountForButtonRoot(root) {
    if (!root || root.nodeType !== 1) return;
    var price = toNumber(root.getAttribute('data-wnow-price'));
    var compareAtPrice = toNumber(root.getAttribute('data-wnow-compare-at-price'));
    if (!price || !compareAtPrice || compareAtPrice <= price) return;

    var discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
    if (!discount || discount < 1) return;

    root.querySelectorAll('.btn-discount').forEach(function (discountEl) {
      discountEl.textContent = discount + '%';
    });
  }

  function applyDiscounts(scope) {
    var roots;
    if (scope && scope.matches && scope.matches('.wnow-buttons')) {
      roots = [scope];
    } else if (scope && scope.querySelectorAll) {
      roots = scope.querySelectorAll('.wnow-buttons');
    } else {
      roots = document.querySelectorAll('.wnow-buttons');
    }
    if (!roots || !roots.length) return;
    roots.forEach(applyDiscountForButtonRoot);
  }

  function init() {
    applyDiscounts(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function (e) {
    applyDiscounts(e.target || document);
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    applyDiscounts(e.target || document);
  });

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (!m.addedNodes || !m.addedNodes.length) return;
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        applyDiscounts(node);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

// Hide the EA sticky cart while the product detail block is visible.
(function () {
  if (window.__hideEaStickyCartWhenProductDetailVisible) return;
  window.__hideEaStickyCartWhenProductDetailVisible = true;

  var hideClass = 'wcpd-hide-ea-sticky-cart';
  var targetSelector = '[data-wcpd-root]';
  var stickySelector = 'body .ea-sticky-cart';
  var rafId = null;

  function injectStyle() {
    if (document.getElementById('wcpd-hide-ea-sticky-cart-style')) return;
    var style = document.createElement('style');
    style.id = 'wcpd-hide-ea-sticky-cart-style';
    style.textContent = 'body.' + hideClass + ' .ea-sticky-cart { display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }';
    document.head.appendChild(style);
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom > 0 && rect.top < vh;
  }

  function setStickyVisible(visible) {
    if (document.body) document.body.classList.toggle(hideClass, !visible);
    document.querySelectorAll(stickySelector).forEach(function (sticky) {
      if (visible) {
        sticky.style.removeProperty('display');
        sticky.style.removeProperty('visibility');
        sticky.style.removeProperty('opacity');
        sticky.style.removeProperty('pointer-events');
      } else {
        sticky.style.setProperty('display', 'none', 'important');
        sticky.style.setProperty('visibility', 'hidden', 'important');
        sticky.style.setProperty('opacity', '0', 'important');
        sticky.style.setProperty('pointer-events', 'none', 'important');
      }
    });
  }

  function checkStickyCart() {
    injectStyle();
    var target = document.querySelector(targetSelector);
    var shouldHide = target && isInViewport(target);
    setStickyVisible(!shouldHide);
  }

  function scheduleCheck() {
    if (rafId != null) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      checkStickyCart();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkStickyCart);
  } else {
    checkStickyCart();
  }
  window.addEventListener('load', checkStickyCart);
  window.addEventListener('scroll', scheduleCheck, { passive: true });
  window.addEventListener('resize', scheduleCheck, { passive: true });
  window.setInterval(checkStickyCart, 500);
})();


// Lazy-load videos inside wpage-template landing pages.
(function () {
  function tryPlay(video) {
    if (!video || typeof video.play !== 'function') return;

    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.catch(function () {});
    }
  }

  function getVideoSources(video) {
    return Array.prototype.slice.call(video.querySelectorAll('source'));
  }

  function prepareVideo(video) {
    if (!video || video.dataset.lazyVideoReady === 'true') return;

    video.dataset.lazyVideoReady = 'true';

    if (!video.getAttribute('preload')) {
      video.setAttribute('preload', 'none');
    }

    getVideoSources(video).forEach(function (source) {
      var src = source.getAttribute('src');
      var dataSrc = source.getAttribute('data-src');

      if (!dataSrc && src) {
        source.setAttribute('data-src', src);
        source.removeAttribute('src');
      }
    });

    var videoSrc = video.getAttribute('src');
    var videoDataSrc = video.getAttribute('data-src');

    if (!videoDataSrc && videoSrc) {
      video.setAttribute('data-src', videoSrc);
      video.removeAttribute('src');
    }
  }

  function loadVideo(video) {
    if (!video || video.dataset.videoLoaded === 'true') return;

    var changed = false;
    var videoDataSrc = video.getAttribute('data-src');

    if (videoDataSrc && !video.getAttribute('src')) {
      video.setAttribute('src', videoDataSrc);
      changed = true;
    }

    getVideoSources(video).forEach(function (source) {
      var dataSrc = source.getAttribute('data-src');
      if (dataSrc && !source.getAttribute('src')) {
        source.setAttribute('src', dataSrc);
        changed = true;
      }
    });

    video.dataset.videoLoaded = 'true';

    if (changed) {
      video.load();
    }

    if (video.autoplay || video.hasAttribute('autoplay')) {
      tryPlay(video);
    }
  }

  function isNearViewport(el, extra) {
    if (!el) return false;

    var rect = el.getBoundingClientRect();
    var winH = window.innerHeight || document.documentElement.clientHeight;
    var offset = extra || 300;

    return rect.top <= winH + offset && rect.bottom >= -offset;
  }

  function bindLazyVideo(video) {
    if (!video || video.dataset.lazyVideoBound === 'true') return;

    if (video.hasAttribute('data-video-eager')) {
      loadVideo(video);
      return;
    }

    video.dataset.lazyVideoBound = 'true';
    prepareVideo(video);

    if (isNearViewport(video, 200)) {
      loadVideo(video);
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadVideo(video);
          observer.disconnect();
        });
      }, {
        rootMargin: '300px 0px'
      });

      observer.observe(video);
    } else {
      loadVideo(video);
    }
  }

  function initPageInnerVideos(scope) {
    var root = scope || document;
    var videos = root.querySelectorAll('.wpage-template video');

    if (!videos.length) return;

    videos.forEach(function (video) {
      bindLazyVideo(video);
    });
  }

  function replayVisibleVideos() {
    document.querySelectorAll('.wpage-template video').forEach(function (video) {
      if (video.dataset.videoLoaded !== 'true') return;
      if (!isNearViewport(video, 100)) return;

      if (video.autoplay || video.hasAttribute('autoplay')) {
        tryPlay(video);
      }
    });
  }

  function boot() {
    initPageInnerVideos(document);

    document.addEventListener('shopify:section:load', function (event) {
      initPageInnerVideos(event.target);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      replayVisibleVideos();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
